import * as types from "../Action/type";

const initialState = {
    loading: false,
    page: 'email',
    error: null,
}
const forgetpassword = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_LOGIN_REQUEST:
            return { ...state, loading: true, error: null };
        case types.FETCH_FORGET_SUCCESS:
            return {
                ...state,
                page: action.payload,
                loading: false,
            };
        default:
            return state;
    }

}
export default forgetpassword;